import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import ransomwareAlert from '../../assets/images/ransomware-alert.png';

function Module5_1() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(true);
  }, [setCanContinue]);
  
  
  // Timer adjust
  const { timeRemaining, formatTime, addPenalty, isRunning } = useTimer();


  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


    // Dynamically add CSS style classes to elements
    const [styledId, setStyledId] = useState(null);
  
    const handleStyleChange = (targetId) => {
      setStyledId(targetId);
    };


  return (
    <div id="module-5_1" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <img src={ransomwareAlert} className={styledId === "bgrnd" ? "img-fluid-restrain hide" : "img-fluid-restrain"} alt="Alert message: Your files are encrypted!"/>
                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module5_1;
